import api from './base';

export const subscriptionsApi = {
  getAll: (token) =>
    api.get('/subscriptions/', {
      headers: { Authorization: `Token ${token}` },
    }),

  getActive: (token) =>
    api.get('/subscriptions/active', {
      headers: { Authorization: `Token ${token}` },
    }),

  getPlans: () => api.get('/subscriptions/plans'),

  getPlan: (planId) => api.get(`/subscriptions/plans/${planId}`),

  subscribe: (planId, paymentData, token) =>
    api.post(
      '/subscriptions/subscribe',
      { plan_id: planId, ...paymentData },
      { headers: { Authorization: `Token ${token}` } }
    ),

  cancel: (subscriptionId, token) =>
    api.post(
      `/subscriptions/${subscriptionId}/cancel`,
      {},
      { headers: { Authorization: `Token ${token}` } }
    ),

  updatePayment: (subscriptionId, paymentData, token) =>
    api.put(`/subscriptions/${subscriptionId}/payment`, paymentData, {
      headers: { Authorization: `Token ${token}` },
    }),

  getInvoices: (token) =>
    api.get('/subscriptions/invoices', {
      headers: { Authorization: `Token ${token}` },
    }),

  getInvoice: (invoiceId, token) =>
    api.get(`/subscriptions/invoices/${invoiceId}`, {
      headers: { Authorization: `Token ${token}` },
    }),

  // Subscription status and details
  getStatus: (token) =>
    api.get('/subscriptions/status/', {
      headers: { Authorization: `Token ${token}` },
    }),

  getDetails: (subscriptionId, token) =>
    api.get(`/subscriptions/${subscriptionId}`, {
      headers: { Authorization: `Token ${token}` },
    }),

  requestUpgrade: (subscriptionId, newPlanId, token) =>
    api.post(`/subscriptions/${subscriptionId}/upgrade`,
      { new_plan_id: newPlanId },
      { headers: { Authorization: `Token ${token}` } }
    ),

  submitRequest: (requestData, token) =>
    api.post('/subscriptions/request', requestData, {
      headers: { Authorization: `Token ${token}` },
    }),
};
